.activityDivider {
  font-size: var(--tuna-typography-fontSize-xs);
  text-transform: uppercase;
}

.sortFilterBar {
  padding: var(--tuna-spacing-1) 0;
}
